import * as React from "react";

function SvgPlateTypeReport(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.103 0C11 0 9.31 1.288 9.31 2.877V4H7v4c0 .794.229 1 1 1h12c.771 0 1-.206 1-1V4h-2.25V2.877C18.75 1.288 17.5 0 16 0h-3.897zM16 4a2 2 0 11-4 0 2 2 0 014 0zM4 6h2v2c0 1.5.5 2 2 2h12c1.5 0 2-.5 2-2V6h2v1h.457c1.928 0 3.491 1.803 3.491 3.731V34H0V11c0-1.928.572-4 2.5-4H4V6zm20 24V14H6.5L4 16.526V30h20zM9 16.526H6.5v2.527H9v-2.527zm4.167 0h-2.5v2.527h2.5v-2.527zm1.666 0h2.5v2.527h-2.5v-2.527zm6.667 0H19v2.527h2.5v-2.527zM9 20.736H6.5v2.527H9v-2.526zm4.167 0h-2.5v2.527h2.5v-2.526zm1.666 0h2.5v2.527h-2.5v-2.526zm6.667 0H19v2.527h2.5v-2.526zm-15 4.211H9v2.527H6.5v-2.527zm4.167 0h2.5v2.527h-2.5v-2.527zm6.666 0h-2.5v2.527h2.5v-2.527zm1.667 0h2.5v2.527H19v-2.527z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgPlateTypeReport;
